<div class="page-loader-container">
  <mat-progress-bar
    [mode]="mode"
    [value]="value"
    [bufferValue]="bufferValue"
  ></mat-progress-bar>
</div>
